const analyticsLog = (str, val = '') =>
    console.log('%c' + str, 'color: blue', val)

// const analyticsErrorLog = (str, val = '') => console.warn(str, val)

const addComponent = (params, comp) => {
    return {
        ...params,
        component: comp || 'unknown',
        page: window.location.pathname.replace('/', '') || 'unknown',
        server: window.location.host.toLowerCase().includes('kita')
            ? 'kita'
            : 'tomy',
    }
}

const track = (name, params = {}, comp) => {
    const mfName = `mf_${name}`
    const cparams = addComponent(params, comp)
    analyticsLog(`analytics track name: ${mfName}, with params`, {...cparams})
    window.analytics.track(mfName, cparams)
}

const pressedButton = (name, params = {}, comp) => {
    track(`pressed_button_${name}`, params, comp)
}

const pressedCreateNewAccount = () => {
    pressedButton('create_new_account', {}, 'Login')
}

const pageLaunch = (pageName) =>
    track(`${pageName.toLowerCase()}_page_launch`, {}, 'Login')

// login

const loginPagePressedLogin = () =>
    track('login_page_pressed_login', {}, 'Login')
const loginPageForgotPassword = () =>
    track('login_page_pressed_forgot_password', {}, 'Login')
const loginPagePressedCreateAccount = () =>
    track('login_page_pressed_createAccount', {}, 'Login')

// sms verification existing user

const verificationExistingUserPressedChangeNumber = () =>
    track(
        'verification_existing_user_pressed_change_number',
        {},
        'SmsVerificationSection'
    )
const verificationExistingUserPressedSendAgain = () =>
    track(
        'verification_existing_user_pressed_send_again',
        {},
        'SmsVerificationSection'
    )
const verificationExistingUserPressedLaunch = () =>
    track(
        'verification_existing_user_pressed_launch',
        {},
        'SmsVerificationSection'
    )

// onboaring:

const onboardingFillOrganizationCode = () =>
    track('onboarding_fill_organization_code', {}, 'RegisterConnectionDetails')
const onboardingPressedNextConnectionDetails = () =>
    track(
        'onboaring_pressed_next_connection_details',
        {},
        'RegisterConnectionDetails'
    )
const onboardingPressedBackPhoneVerification = () =>
    track(
        'onboaring_pressed_back_phone_verification',
        {},
        'RegisterPhoneVerification'
    )
const onboardingPressedSendAgainPhoneVerification = () =>
    track(
        'onboarding_pressed_send_again_phone_verfication',
        {},
        'RegisterPhoneVerification'
    )
const onboardingPressedNextPhoneVerification = () =>
    track(
        'onboarding_pressed_next_phone_verification',
        {},
        'RegisterPhoneVerification'
    )
const onboardingPressedBackCreatePassword = () =>
    track(
        'onboaring_pressed_back_create_password',
        {},
        'RegisterCreatePassword'
    )
const onboardingPressedNextCreatePassword = () =>
    track(
        'onboarding_pressed_next_create_password',
        {},
        'RegisterCreatePassword'
    )
const onboardingPressedBackPersonalDetails = () =>
    track(
        'onboaring_pressed_back_personal_details',
        {},
        'RegisterPersonalDetails'
    )
const onboardingPressedFemale = () =>
    track('onboaring_pressed_female', {}, 'RegisterPersonalDetails')
const onboardingPressedMale = () =>
    track('onboaring_pressed_male', {}, 'RegisterPersonalDetails')
const onboardingPressedNextPersonalDetails = () =>
    track(
        'onboarding_pressed_next_personal_details',
        {},
        'RegisterPersonalDetails'
    )
const onboardingCreateAccount = () =>
    track('onboarding_create_account', {}, 'RegisterSignupSuccess')
const onboardingPressedLogin = () =>
    track('onboarding_pressed_login', {}, 'RegisterSignupSuccess')

// nav tool

const navToolPressed = (name) =>
    track(`nav_tool_pressed_${name}`, {}, 'NavTool')

// home

const homePressed = (name, params = {}) =>
    track(`home_pressed_${name}`, params, 'Dashboard')

// new client

const newClientPressedCancel = () =>
    track('new_client_pressed_cancel', {}, 'NewClient')
const newClientPressedSave = () =>
    track('new_client_pressed_save', {}, 'NewClient')

// existing client

const existingClientPressed = (name, params = {}) =>
    track(`existing_client_pressed_${name}`, params, 'Client')

// clients

const clientsPressed = (name, params = {}) =>
    track(`clients_pressed_${name}`, params, 'Clients')

// settings

const profileSettingsPressed = (name, params = {}) =>
    track(`profile_settings_pressed_${name}`, params, 'Settings')
const paymentSettingsPressed = (name, params = {}) =>
    track(`payment_settings_pressed_${name}`, params, 'Settings')

// forgot password

const forgotPasswordPressed = (name, params = {}) =>
    track(`forgot_password_pressed_${name}`, params, 'ForgotPassword')

const analyticsService = {
    track,
    pressedCreateNewAccount,
    pageLaunch,
    loginPagePressedLogin,
    loginPageForgotPassword,
    loginPagePressedCreateAccount,
    verificationExistingUserPressedChangeNumber,
    verificationExistingUserPressedSendAgain,
    verificationExistingUserPressedLaunch,
    onboardingFillOrganizationCode,
    onboardingPressedNextConnectionDetails,
    onboardingPressedBackPhoneVerification,
    onboardingPressedSendAgainPhoneVerification,
    onboardingPressedNextPhoneVerification,
    onboardingPressedBackCreatePassword,
    onboardingPressedNextCreatePassword,
    onboardingPressedBackPersonalDetails,
    onboardingPressedFemale,
    onboardingPressedMale,
    onboardingPressedNextPersonalDetails,
    onboardingCreateAccount,
    onboardingPressedLogin,
    navToolPressed,
    homePressed,
    newClientPressedCancel,
    newClientPressedSave,
    existingClientPressed,
    clientsPressed,
    profileSettingsPressed,
    paymentSettingsPressed,
    forgotPasswordPressed,
}

export default analyticsService
